"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _radio = _interopRequireDefault(require("../Radio/radio"));

var _checkbox = _interopRequireDefault(require("../Checkbox/checkbox"));

var _media = _interopRequireDefault(require("../Media/media"));

var _itemContent = _interopRequireDefault(require("./itemContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function wrapItemContents(itemChildren) {
  var itemsArr = _react.default.Children.toArray(itemChildren);

  var processedChildren = itemsArr.map(function (child, index) {
    if (child.props && child.props.noWrap) return child;
    var isMedia = (0, _compareElementType.default)(child, _media.default);
    var isCheckbox = (0, _compareElementType.default)(child, _checkbox.default);
    var isRadio = (0, _compareElementType.default)(child, _radio.default);
    var isItemContent = (0, _compareElementType.default)(child, _itemContent.default);
    var isString = typeof child === 'string';
    var isNumeric = typeof child === 'number';

    var isValidElement = _react.default.isValidElement(child);

    var shouldWrap = !isItemContent && (isValidElement || isMedia || isCheckbox || isRadio || isString || isNumeric);
    return shouldWrap ? _react.default.createElement(_itemContent.default, {
      key: index
    }, child) : child;
  });
  return processedChildren;
}

var ClickableChildren = _react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      focused = _ref.focused;

  var onClickHandler = function onClickHandler(e) {
    e.preventDefault();
    onClick(e);
  };

  return _react.default.createElement(_styler.default, {
    classNames: "co-list__link-item",
    modifiers: {
      focused: focused
    }
  }, function (styles) {
    return _react.default.createElement("a", {
      className: styles,
      href: "#",
      onClick: onClickHandler,
      ref: ref
    }, children);
  });
});

var Item = _react.default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      onClick = _ref2.onClick,
      withDescription = _ref2.withDescription,
      borderBottom = _ref2.borderBottom,
      borderTop = _ref2.borderTop,
      active = _ref2.active,
      danger = _ref2.danger,
      disabled = _ref2.disabled,
      onKeyUp = _ref2.onKeyUp,
      onKeyPress = _ref2.onKeyPress,
      onKeyDown = _ref2.onKeyDown,
      focused = _ref2.focused,
      id = _ref2.id,
      props = _objectWithoutProperties(_ref2, ["children", "onClick", "withDescription", "borderBottom", "borderTop", "active", "danger", "disabled", "onKeyUp", "onKeyPress", "onKeyDown", "focused", "id"]);

  var itemClasses = ['co-list__item', {
    'co-list__item--with-description': withDescription
  }];
  var allowedModifiers = {
    active: active,
    borderBottom: borderBottom,
    borderTop: borderTop,
    danger: danger,
    disabled: disabled
  };
  var processedChildren = wrapItemContents(children);
  return _react.default.createElement(_styler.default, {
    classNames: itemClasses,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("li", _extends({
      className: styles,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
      onKeyUp: onKeyUp,
      id: id,
      "aria-selected": active
    }, (0, _getNativeProps.default)(props)), onClick ? _react.default.createElement(ClickableChildren, {
      focused: focused,
      ref: ref,
      onClick: onClick
    }, processedChildren) : processedChildren);
  });
});

Item.propTypes = {
  children: _propTypes.any.isRequired,
  active: _propTypes.bool,
  borderTop: _propTypes.bool,
  borderBottom: _propTypes.bool,
  danger: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@onClick@@ @@disabled@@ */
  disabled: _propTypes.bool,
  withDescription: _propTypes.bool,

  /** {func} Mutually exclusive props: @@onClick@@ @@disabled@@ */
  onClick: _propTypes.func,
  focused: _propTypes.bool,
  id: _propTypes.string,
  onKeyDown: _propTypes.func,
  onKeyPress: _propTypes.func,
  onKeyUp: _propTypes.func
};
Item.displayName = 'List.Item';
ClickableChildren.displayName = 'ClickableChildren';
var _default = Item;
exports.default = _default;
Item.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "List.Item",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "borderTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "borderBottom": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "danger": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@onClick@@ @@disabled@@"
    },
    "withDescription": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "{func} Mutually exclusive props: @@onClick@@ @@disabled@@"
    },
    "focused": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onKeyDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyPress": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};